export default "Lav jeres egne simple minibåde af materialer fra naturen – kan de mon flyde?";